module.exports = __webpack_public_path__ + "img/ic_clear.62a4b849.svg";